import React, { useState } from "react";
import { Header } from "../header";
import Spacer from "../Spacer";
import { IMG_URl } from "../../common/img_url";
import Visibility from "../utils/Visibility";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { indexStore } from "../../store/indexStore";
import OptionsProduct from "../OptionsProduct/OptionsProduct";

import { Skeleton } from "../ui/skeleton";
import {
  ProductCartElement,
  ProductDetails,
  ProductTags,
} from "./ProductElemnts";
import Iterator from "../utils/Iterator";
import ProductModel from "../../Models/PorductModel";

function OldProductScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { name, description, product, itemLoading } = indexStore();
  const params = useParams();

  const [optionsSelected, setOptionsSelected] = useState([]);

  return (
    <>
      <Visibility visible={!itemLoading}>
        <div className="z-[1] relative overflow-hidden flex flex-col gap-2 items-center">
          <Header backgroundColorfull={true} />
          <div className="absolute bg-primary -left-[100px] -right-[100px] -top-[100px] bottom-[25px] rounded-br-[500px] rounded-bl-[500px] z-[-1]"></div>
          <Spacer height={15} />
          <p className="text-onPrimary capitalize text-3xl text-center py-2">
            {product?.[name as keyof ProductModel]?.toString()}
          </p>
          <Spacer height={10} />
          <img
            className="w-[55vw] aspect-square rounded-md  object-cover"
            src={`${IMG_URl}${product.image}`}
            alt="logo"
          />
        </div>
        <Spacer height={20} />
        <div className="flex text-onBackground flex-col gap-4 justify-between p-4  rounded-2xl shadow-md m-7 mb-24 bg-background  ">
          <ProductTags product={product} t={t} />
          <ProductDetails
            product={product}
            name={name}
            description={description}
          />
          <Visibility visible={product.option && product.option.length > 0}>
            <OptionsProduct
              options={product.option}
              name={name}
              price={product.price_offer || product.price}
              setOptionsSelected={setOptionsSelected}
              optionsSelected={optionsSelected}
            />
          </Visibility>
          <ProductCartElement
            product={product}
            t={t}
            navigate={navigate}
            params={params}
            optionsSelected={optionsSelected}
            itemLoading={itemLoading}
            productSheet={false}
          />
        </div>
      </Visibility>
      <Visibility visible={itemLoading}>
        <RenderProduct
          ProductCartElement={
            <ProductCartElement
              product={product}
              t={t}
              navigate={navigate}
              params={params}
              optionsSelected={optionsSelected}
              itemLoading={itemLoading}
              productSheet={false}
            />
          }
        />
      </Visibility>
    </>
  );
}

export default OldProductScreen;
const RenderProduct = ({ ProductCartElement }:any) => {
  return (
    <>
      <div className="z-[1] relative overflow-hidden flex flex-col gap-2 items-center">
        <Skeleton className={"w-full h-16"} />
        <Skeleton className="absolute -left-[100px] -right-[100px] -top-[100px] bottom-[25px] rounded-br-[500px] rounded-bl-[500px] z-[-1]" />
        <Spacer height={15} />
        <Skeleton className={"w-48 h-10"} />
        <Spacer height={10} />
        <Skeleton className="w-[55vw] aspect-square  object-cover" />
      </div>
      <Spacer height={20} />
      <div className="flex text-onBackground flex-col gap-4 justify-between p-4 mb-24 rounded-2xl shadow-md m-7 bg-background  ">
        <div className="flex gap-1 flex-wrap">
          <Skeleton className={"w-12 h-7"} />
          <Skeleton className={"w-12 h-7"} />
          <Skeleton className={"w-12 h-7"} />
        </div>
        <Skeleton className="w-48 h-5" />
        <div className="text-base font-semibold flex justify-end ">
          <Skeleton className={"w-12 h-7"} />
        </div>
        <div className="flex flex-col gap-3 ">
          <Skeleton className={"w-20 h-5"} />
          <div className="flex flex-col gap-2">
            <div className="px-1 flex flex-col gap-2">
              <Skeleton className={"w-16 h-5"} />
              <div className="px-2 flex flex-col gap-1 ">
                <Iterator
                  data={[1, 2, 3]}
                  render={() => (
                    <div className="flex items-center gap-3">
                      <Skeleton className={"w-4 h-4 rounded-full"} />
                      <Skeleton className={"w-40 h-5"} />
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
          <div className="border-b-2 border-onBackground"></div>
          <div className="flex gap-1 justify-end">
            <Skeleton className={"w-40 h-6"} />
          </div>
        </div>
        {ProductCartElement}
      </div>
    </>
  );
};
